import { getPathPropsInterface } from '../../../interfaces/commonInterfaces';

const getPath = (name: string, props: getPathPropsInterface) => {
  const fillColor = 'var(--background-primary)';
  const borderColor = 'var(--border-secondary)';
  const iconColor = 'var(--text-primary)';
  switch (name) {
    // folder file icon
    case 'icon_1':
    case '.folder':
      return (
        <>
          <path
            fill='#F5B800'
            d='m28.125 15-2.378-2.377a4.688 4.688 0 0 0-3.314-1.373H6.563a2.812 2.812 0 0 0-2.813 2.813v31.874a2.813 2.813 0 0 0 2.813 2.813h46.874a2.813 2.813 0 0 0 2.813-2.813V17.814A2.813 2.813 0 0 0 53.437 15H28.125Z'
          />
          <path
            fill='#B64D07'
            d='M5.625 47.813a2.776 2.776 0 0 1-1.457-.419 2.8 2.8 0 0 0 2.394 1.356h46.875a2.8 2.8 0 0 0 2.395-1.355 2.789 2.789 0 0 1-1.457.418H5.625Z'
          />
          <path
            fill={fillColor}
            d='m26.492 18.04 3.04-3.04h-1.407l-2.378 2.378a4.688 4.688 0 0 1-3.314 1.372H3.75v.938h18.763a5.625 5.625 0 0 0 3.979-1.649Z'
            opacity={0.4}
          />
        </>
      );
    // teamcamp doc file icon
    case 'icon_3':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <rect width={27.906} height={2} x={16.047} y={28.116} fill='#00A16F' rx={1} />
          <rect width={27.906} height={2} x={16.047} y={34.616} fill='#00A16F' rx={1} />
          <rect width={27.906} height={2} x={16.047} y={41.116} fill='#00A16F' rx={1} />
          <rect width={13.344} height={2} x={16.047} y={47.616} fill='#00A16F' rx={1} />
          <g fill='#00A16F' clipPath='url(#clip0_31556_199566)'>
            <path d='m20.21 10.976.988 1.89c1.075 2.056-.391 4.535-2.682 4.535h-1.993v-2.287h1.993c.594 0 .974-.643.695-1.176l-.988-1.89 1.987-1.072ZM24.085 10.976l-.988 1.89c-1.075 2.056.391 4.535 2.682 4.535h1.994v-2.287h-1.994c-.594 0-.974-.643-.695-1.176l.988-1.89-1.987-1.072ZM22.091 19.699l-1.718 2.527-1.851-1.3 1.718-2.528a2.23 2.23 0 0 1 3.702 0l1.718 2.527-1.85 1.3L22.09 19.7Z' />
          </g>
          <defs>
            <clipPath id='clip0_31556_199566'>
              <path fill={fillColor} d='M16.047 10.5h12v12h-12z' />
            </clipPath>
          </defs>
        </>
      );
    // google drive icon
    case 'icon_4':
      return (
        <>
          <path
            fill='var(--background-primary)'
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill='var(--background-primary)' d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill='var(--border-secondary)'
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.831 2.831 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#clip0_29594_140611)'>
            <path
              fill='#0066DA'
              d='m20.663 40.846.97 1.676c.202.352.492.63.832.831l3.465-5.998H19c0 .391.1.782.302 1.135l1.361 2.356Z'
            />
            <path
              fill='#00AC47'
              d='m30 30.3-3.465-5.997c-.34.201-.63.479-.832.831l-6.4 11.089A2.283 2.283 0 0 0 19 37.357h6.93L30 30.3Z'
            />
            <path
              fill='#EA4335'
              d='M37.535 43.353c.34-.201.63-.479.832-.831l.403-.693 1.928-3.34c.201-.352.302-.743.302-1.133h-6.93l1.474 2.898 1.99 3.1Z'
            />
            <path
              fill='#00832D'
              d='m30 30.3 3.465-5.998A2.215 2.215 0 0 0 32.331 24h-4.662c-.403 0-.794.113-1.134.302L30 30.3Z'
            />
            <path
              fill='#2684FC'
              d='M34.07 37.355h-8.14l-3.465 5.998c.34.202.73.303 1.134.303h12.802c.403 0 .794-.114 1.134-.303l-3.465-5.998Z'
            />
            <path
              fill='#FFBA00'
              d='m37.497 30.678-3.2-5.544a2.288 2.288 0 0 0-.832-.831L30 30.3l4.07 7.057h6.917c0-.391-.1-.782-.302-1.134l-3.188-5.545Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_29594_140611'>
              <path fill='#fff' d='M19 24h22v19.656H19z' />
            </clipPath>
          </defs>
        </>
      );
    // dropbox file icon
    case 'icon_5':
      return (
        <>
          <path
            fill='var(--background-primary)'
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill='var(--background-primary)' d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill='var(--border-secondary)'
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.831 2.831 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#clip0_29594_140590)'>
            <path
              fill='#007EE5'
              d='M25.395 23.768 19 27.912l4.451 3.581 6.395-3.99-4.45-3.735ZM19 34.972l6.395 4.196 4.451-3.735-6.395-3.94L19 34.973Zm10.846.46 4.503 3.736 6.344-4.145-4.4-3.53-6.447 3.94Zm10.847-7.52-6.344-4.144-4.502 3.735 6.446 3.99 4.4-3.581Zm-10.795 8.34-4.503 3.734-1.893-1.279v1.433l6.396 3.837 6.395-3.837v-1.433l-1.944 1.28-4.451-3.736Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_29594_140590'>
              <path fill='#fff' d='M19 23.768h22v20.465H19z' />
            </clipPath>
          </defs>
        </>
      );
    // one drive file icon
    case 'icon_6':
      return (
        <>
          <path
            fill='var(--background-primary)'
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill='var(--background-primary)' d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill='var(--border-secondary)'
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#clip0_29594_140544)'>
            <path
              fill='#0364B8'
              d='m27.39 31.117 4.618 2.766 2.752-1.159a4.452 4.452 0 0 1 2.073-.353 6.876 6.876 0 0 0-12.403-2.072l.07-.002a5.473 5.473 0 0 1 2.89.82Z'
            />
            <path
              fill='#0078D4'
              d='M27.39 31.116v.001a5.473 5.473 0 0 0-2.89-.82l-.07.002a5.497 5.497 0 0 0-4.442 8.642l4.073-1.714 1.81-.762 4.032-1.697 2.105-.885-4.619-2.767Z'
            />
            <path
              fill='#1490DF'
              d='M36.833 32.37a4.452 4.452 0 0 0-2.073.354l-2.752 1.159.798.478 2.616 1.567 1.141.683 3.902 2.338a4.469 4.469 0 0 0-3.632-6.578Z'
            />
            <path
              fill='#28A8EA'
              d='m36.563 36.611-1.141-.683-2.616-1.567-.798-.478-2.106.886-4.03 1.696-1.811.762-4.073 1.714a5.493 5.493 0 0 0 4.512 2.356H36.53a4.469 4.469 0 0 0 3.934-2.348l-3.902-2.338Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_29594_140544'>
              <path fill='#fff' d='M19 27.203h22v14.094H19z' />
            </clipPath>
          </defs>
        </>
      );
    case 'icon_7':
    case '.figma':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='#00BCFF' d='M30.026 33a3.833 3.833 0 1 1 7.667 0 3.833 3.833 0 0 1-7.667 0Z' />
          <path
            fill='#00CF7F'
            d='M22.36 40.667a3.833 3.833 0 0 1 3.833-3.834l2.043-1.078 1.79 1.078v3.834a3.833 3.833 0 0 1-7.667 0Z'
          />
          <path fill='#FF7361' d='m30.027 21.5-2.086 3.624 2.086 4.043h3.78a3.833 3.833 0 1 0 0-7.667h-3.78Z' />
          <path
            fill='#FF4D12'
            d='M22.307 25.333a3.833 3.833 0 0 0 3.833 3.834l2.034.785 1.853-.785V21.5H26.14a3.833 3.833 0 0 0-3.833 3.833Z'
          />
          <path
            fill='#B659FF'
            d='M22.36 33a3.833 3.833 0 0 0 3.833 3.834h3.833v-7.667h-3.833A3.833 3.833 0 0 0 22.359 33Z'
          />
        </>
      );
    // whiteboard file icon
    case 'icon_8':
      return (
        <>
          <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12.1875 54.375H47.8125C48.3281 54.375 48.75 53.9531 48.75 53.4375V16.875H40.3125C38.7619 16.875 37.5 15.6131 37.5 14.0625V5.625H12.1875C11.6719 5.625 11.25 6.04688 11.25 6.5625V53.4375C11.25 53.9531 11.6719 54.375 12.1875 54.375Z'
              fill={fillColor}
            />
            <path
              d='M48 18.0001V17.1211L39 8.12109V16.5001C39 17.3251 39.675 18.0001 40.5 18.0001H48Z'
              fill={fillColor}
            />
            <path
              opacity='0.67'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M49.8 14.7262L39.6488 4.57312C39.1203 4.04795 38.4062 3.7522 37.6613 3.75H12.1875C10.6369 3.75 9.375 5.01187 9.375 6.5625V53.4375C9.375 54.9881 10.6369 56.25 12.1875 56.25H47.8125C49.3631 56.25 50.625 54.9881 50.625 53.4375V16.7137C50.625 15.9637 50.3325 15.2569 49.8 14.7262ZM39.375 6.95062L47.4244 15H40.3125C40.064 14.9995 39.8258 14.9006 39.6501 14.7249C39.4744 14.5492 39.3755 14.311 39.375 14.0625V6.95062ZM12.1875 54.375H47.8125C48.3281 54.375 48.75 53.9531 48.75 53.4375V16.875H40.3125C38.7619 16.875 37.5 15.6131 37.5 14.0625V5.625H12.1875C11.6719 5.625 11.25 6.04688 11.25 6.5625V53.4375C11.25 53.955 11.67 54.375 12.1875 54.375Z'
              fill={borderColor}
            />
            <path
              d='M32.708 38.5703L29.9942 35.8564L27.2804 38.5703L29.9942 41.2841L32.708 38.5703ZM23.2549 46.3843L20.5411 43.6704L17.8273 46.3843L20.5411 49.0981L23.2549 46.3843Z'
              fill='#00A16F'
            />
            <path
              d='M22.7812 46.3844L20.5386 48.6269L18.2959 46.3844L20.5386 44.1416L22.7812 46.3844Z'
              fill='#00A16F'
            />
            <path
              d='M27.2057 29.5198V31.346C27.2057 31.9529 27.6977 32.4449 28.3046 32.4449H31.6785C32.2854 32.4449 32.7773 31.9529 32.7773 31.346V29.5198C32.7773 28.9129 32.2854 28.4209 31.6785 28.4209H28.3046C27.6977 28.4209 27.2057 28.9129 27.2057 29.5198ZM27.5293 46.2617C27.5293 47.6196 28.6317 48.7219 29.9896 48.7219C31.3514 48.7219 32.4537 47.6196 32.4537 46.2617C32.4537 44.8999 31.3513 43.7976 29.9896 43.7976C28.6317 43.7976 27.5293 44.8999 27.5293 46.2617ZM22.2532 36.8549H18.8202V40.2879H22.2532V36.8549Z'
              fill={fillColor}
            />
            <path
              d='M20.2055 43.5323V40.6208H18.8225C18.7787 40.6209 18.7353 40.6122 18.6949 40.5955C18.6544 40.5787 18.6176 40.5542 18.5866 40.5232C18.5557 40.4922 18.5311 40.4554 18.5143 40.415C18.4976 40.3745 18.489 40.3311 18.489 40.2873V36.8543C18.489 36.8105 18.4976 36.7671 18.5143 36.7267C18.5311 36.6862 18.5557 36.6494 18.5866 36.6184C18.6176 36.5875 18.6544 36.5629 18.6949 36.5461C18.7353 36.5294 18.7787 36.5208 18.8225 36.5208H22.2555C22.2993 36.5208 22.3427 36.5294 22.3831 36.5461C22.4236 36.5629 22.4604 36.5875 22.4914 36.6184C22.5223 36.6494 22.5469 36.6862 22.5637 36.7267C22.5804 36.7671 22.589 36.8105 22.589 36.8543V38.2373H27.1416L29.6603 35.7186V32.7777H28.307C27.5172 32.7777 26.8746 32.1355 26.8746 31.3456V29.5194C26.8745 28.7295 27.5171 28.0869 28.307 28.0869H31.6808C32.4706 28.0869 33.1133 28.7295 33.1133 29.5194V31.3456C33.1133 32.1355 32.4706 32.7777 31.6808 32.7777H30.3273V35.7186L32.9439 38.335C32.9749 38.3659 32.9995 38.4027 33.0162 38.4432C33.033 38.4836 33.0416 38.527 33.0416 38.5708C33.0416 38.6146 33.033 38.658 33.0162 38.6984C32.9995 38.7389 32.9749 38.7756 32.9439 38.8066L30.3272 41.4234L30.3258 43.4854C31.7113 43.6512 32.7895 44.8317 32.7895 46.2611C32.7895 47.8017 31.5346 49.055 29.992 49.055C28.4514 49.055 27.1981 47.8017 27.1981 46.2611C27.1981 44.8317 28.275 43.6512 29.6587 43.4854L29.6602 41.4232L27.1416 38.9043H22.589V40.2873C22.589 40.3311 22.5804 40.3744 22.5637 40.4149C22.5469 40.4554 22.5223 40.4922 22.4914 40.5231C22.4604 40.5541 22.4236 40.5787 22.3831 40.5954C22.3427 40.6122 22.2993 40.6208 22.2555 40.6208H20.8725V43.5323L23.4891 46.1491C23.5201 46.18 23.5447 46.2168 23.5614 46.2572C23.5782 46.2977 23.5868 46.3411 23.5868 46.3849C23.5868 46.4287 23.5782 46.472 23.5614 46.5125C23.5447 46.5529 23.5201 46.5897 23.4891 46.6207L20.7748 49.3348C20.7439 49.3658 20.7071 49.3904 20.6666 49.4071C20.6262 49.4239 20.5828 49.4325 20.539 49.4325C20.4952 49.4325 20.4519 49.4239 20.4114 49.4071C20.3709 49.3904 20.3342 49.3658 20.3032 49.3348L17.5889 46.6207C17.5579 46.5897 17.5334 46.5529 17.5166 46.5125C17.4998 46.472 17.4912 46.4287 17.4912 46.3849C17.4912 46.3411 17.4998 46.2977 17.5166 46.2572C17.5334 46.2168 17.5579 46.18 17.5889 46.1491L20.2055 43.5323ZM32.4462 31.3456V29.5194C32.4462 29.0972 32.1029 28.754 31.6808 28.754H28.307C27.8848 28.754 27.5416 29.0972 27.5416 29.5194V31.3456C27.5416 31.7674 27.8848 32.1107 28.307 32.1107H31.6808C32.1029 32.1107 32.4462 31.7674 32.4462 31.3456ZM27.8651 46.2611C27.8651 47.434 28.8193 48.388 29.992 48.388C31.1666 48.388 32.1225 47.434 32.1225 46.2611C32.1225 45.0863 31.1667 44.1307 29.992 44.1307C28.8193 44.1307 27.8651 45.0863 27.8651 46.2611ZM29.9938 40.8136L32.2364 38.5708L29.9938 36.3283L27.7513 38.5708L29.9938 40.8136ZM21.9219 37.1879H19.156V39.9538H21.9219V37.1879ZM20.539 48.6274L22.7817 46.3849L20.539 44.1421L18.2963 46.3849L20.539 48.6274Z'
              fill='#00A16F'
            />
            <path
              d='M39.7899 40.6208V43.5323L42.4064 46.1491C42.4374 46.18 42.462 46.2168 42.4787 46.2572C42.4955 46.2977 42.5041 46.3411 42.5041 46.3849C42.5041 46.4287 42.4955 46.472 42.4787 46.5125C42.462 46.5529 42.4374 46.5897 42.4064 46.6207L39.6921 49.3348C39.6612 49.3658 39.6244 49.3904 39.584 49.4071C39.5435 49.4239 39.5001 49.4325 39.4563 49.4325C39.4125 49.4325 39.3692 49.4239 39.3287 49.4071C39.2882 49.3904 39.2515 49.3658 39.2205 49.3348L36.5062 46.6207C36.4752 46.5897 36.4507 46.5529 36.4339 46.5125C36.4171 46.472 36.4085 46.4287 36.4085 46.3849C36.4085 46.3411 36.4171 46.2977 36.4339 46.2572C36.4507 46.2168 36.4752 46.18 36.5062 46.1491L39.1228 43.5323V40.6208H37.7399C37.6961 40.6208 37.6527 40.6122 37.6122 40.5954C37.5717 40.5787 37.535 40.5541 37.504 40.5231C37.473 40.4922 37.4484 40.4554 37.4317 40.4149C37.4149 40.3744 37.4063 40.3311 37.4063 40.2873V38.9043H32.8538L32.8537 38.2373H37.4063V36.8543C37.4063 36.8105 37.4149 36.7671 37.4317 36.7267C37.4484 36.6862 37.473 36.6494 37.504 36.6184C37.535 36.5875 37.5717 36.5629 37.6122 36.5461C37.6527 36.5294 37.6961 36.5208 37.7399 36.5208H41.1728C41.2166 36.5208 41.26 36.5294 41.3005 36.5461C41.341 36.5629 41.3777 36.5875 41.4087 36.6184C41.4397 36.6494 41.4643 36.6862 41.481 36.7267C41.4978 36.7671 41.5064 36.8105 41.5064 36.8543V40.2873C41.5064 40.3311 41.4978 40.3745 41.481 40.415C41.4643 40.4554 41.4397 40.4922 41.4087 40.5232C41.3777 40.5542 41.341 40.5787 41.3005 40.5955C41.26 40.6122 41.2166 40.6209 41.1728 40.6208H39.7899Z'
              fill='#00A16F'
            />
            <path d='M38.0895 37.1856H40.8602V39.9563H38.0895V37.1856Z' fill={fillColor} />
            <g clip-path='url(#clip0_31606_61819)'>
              <path
                d='M20.2104 10.9756L21.198 12.8651C22.2729 14.9216 20.8066 17.4014 18.5156 17.4014H16.5225V15.1143H18.5156C19.1096 15.1143 19.4897 14.4714 19.2111 13.9382L18.2234 12.0487L20.2104 10.9756Z'
                fill='#00A16F'
              />
              <path
                d='M24.0846 10.9756L23.0969 12.8651C22.022 14.9216 23.4883 17.4014 25.7793 17.4014H27.7725V15.1143H25.7793C25.1853 15.1143 24.8052 14.4714 25.0839 13.9382L26.0715 12.0487L24.0846 10.9756Z'
                fill='#00A16F'
              />
              <path
                d='M22.0912 19.6986L20.3729 22.2256L18.522 20.9252L20.2402 18.3982C21.1348 17.0826 23.0475 17.0826 23.9421 18.3982L25.6604 20.9252L23.8094 22.2256L22.0912 19.6986Z'
                fill='#00A16F'
              />
            </g>
            <defs>
              <clipPath id='clip0_31606_61819'>
                <rect width='12' height='12' fill={fillColor} transform='translate(16.0469 10.5)' />
              </clipPath>
            </defs>
          </svg>
        </>
      );
    // notion
    case 'icon_9':
      return (
        <>
          <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12.1875 54.375H47.8125C48.3281 54.375 48.75 53.9531 48.75 53.4375V16.875H40.3125C38.7619 16.875 37.5 15.6131 37.5 14.0625V5.625H12.1875C11.6719 5.625 11.25 6.04688 11.25 6.5625V53.4375C11.25 53.9531 11.6719 54.375 12.1875 54.375Z'
              fill={fillColor}
            />
            <path
              d='M48 18.0001V17.1211L39 8.12109V16.5001C39 17.3251 39.675 18.0001 40.5 18.0001H48Z'
              fill={fillColor}
            />
            <path
              opacity='0.67'
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M49.8 14.7262L39.6488 4.57312C39.1203 4.04795 38.4062 3.7522 37.6613 3.75H12.1875C10.6369 3.75 9.375 5.01187 9.375 6.5625V53.4375C9.375 54.9881 10.6369 56.25 12.1875 56.25H47.8125C49.3631 56.25 50.625 54.9881 50.625 53.4375V16.7137C50.625 15.9637 50.3325 15.2569 49.8 14.7262ZM39.375 6.95062L47.4244 15H40.3125C40.064 14.9995 39.8258 14.9006 39.6501 14.7249C39.4744 14.5492 39.3755 14.311 39.375 14.0625V6.95062ZM12.1875 54.375H47.8125C48.3281 54.375 48.75 53.9531 48.75 53.4375V16.875H40.3125C38.7619 16.875 37.5 15.6131 37.5 14.0625V5.625H12.1875C11.6719 5.625 11.25 6.04688 11.25 6.5625V53.4375C11.25 53.955 11.67 54.375 12.1875 54.375Z'
              fill={borderColor}
            />
            <path
              d='M23.6401 28.4284C24.2696 28.9398 24.5058 28.9008 25.6879 28.8219L36.8324 28.1527C37.0687 28.1527 36.8722 27.9169 36.7935 27.8778L34.9425 26.5397C34.5879 26.2644 34.1153 25.9491 33.2098 26.028L22.4186 26.815C22.025 26.8541 21.9464 27.0508 22.1032 27.2086L23.6401 28.4284ZM24.3092 31.0256V42.7516C24.3092 43.3818 24.6241 43.6176 25.3329 43.5786L37.5807 42.8699C38.2899 42.8309 38.3689 42.3973 38.3689 41.8855V30.2382C38.3689 29.7271 38.1723 29.4514 37.7381 29.4908L24.939 30.2382C24.4667 30.2779 24.3092 30.5141 24.3092 31.0256ZM36.4002 31.6546C36.4788 32.0091 36.4002 32.3633 36.045 32.4031L35.4549 32.5207V41.1775C34.9425 41.453 34.4701 41.6104 34.0764 41.6104C33.446 41.6104 33.2881 41.4135 32.816 40.8236L28.9559 34.7637V40.6269L30.1773 40.9024C30.1773 40.9024 30.1773 41.6104 29.1919 41.6104L26.4751 41.768C26.3962 41.6104 26.4751 41.2173 26.7507 41.1384L27.4596 40.942V33.1899L26.4753 33.111C26.3963 32.7565 26.593 32.2454 27.1447 32.2057L30.0592 32.0093L34.0764 38.148V32.7175L33.0521 32.5999C32.9735 32.1665 33.2881 31.8518 33.682 31.8128L36.4002 31.6546ZM21.5125 25.7526L32.7372 24.926C34.1156 24.8078 34.4702 24.887 35.3366 25.5163L38.9196 28.0347C39.5109 28.4677 39.7079 28.5856 39.7079 29.0577V42.8699C39.7079 43.7354 39.3926 44.2474 38.29 44.3257L25.2549 45.1129C24.4273 45.1524 24.0334 45.0344 23.6 44.4831L20.9614 41.0597C20.4886 40.4296 20.292 39.9581 20.292 39.4065V27.1294C20.292 26.4215 20.6074 25.831 21.5125 25.7526Z'
              fill={iconColor}
            />
          </svg>
        </>
      );
    case '.iconpdf':
    case '.pdf':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='#C8C6C4' d='M43.5 30h-27a1.5 1.5 0 0 1 0-3h27a1.5 1.5 0 0 1 0 3Z' />
          <path
            fill='#D65532'
            fillRule='evenodd'
            d='M18 48V36a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H21a3 3 0 0 1-3-3Zm3.6 0h16.782a.584.584 0 0 0 .6-.588c-.018-2.034.006-8.796.018-10.83 0-.33-.27-.582-.6-.582H21.6c-.33 0-.6.27-.6.6v10.8a.6.6 0 0 0 .6.6Zm-7.35 0H9a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h5.25a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75Zm31.5 0H51a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3h-5.25a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75Z'
            clipRule='evenodd'
          />
        </>
      );

    case '.docx':
    case '.doc':
      return (
        <>
          <path
            fill={fillColor}
            d='M18.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='#103F91' d='M47.813 41.25H31.874v1.875h15.938a.938.938 0 0 0 0-1.875Z' />
          <path fill='#185ABD' d='M47.813 35.625H31.874V37.5h15.938a.938.938 0 0 0 0-1.875Z' />
          <path fill='#2B7CD3' d='M47.813 30H31.874v1.875h15.938a.938.938 0 0 0 0-1.875Z' />
          <path fill='#41A5EE' d='M47.813 24.375H31.874v1.875h15.938a.938.938 0 0 0 0-1.875Z' />
          <path
            fill='#185ABD'
            d='M6.563 46.875h20.625A2.813 2.813 0 0 0 30 44.062V23.439a2.813 2.813 0 0 0-2.813-2.813H6.563a2.812 2.812 0 0 0-2.812 2.813v20.625a2.813 2.813 0 0 0 2.813 2.812Z'
          />
          <path
            fill='#F9F7F7'
            d='M13.528 38.869h.041c.017-.216 2.125-10.744 2.125-10.744h2.448s2.138 10.037 2.204 10.725h.032c.028-.473 1.77-10.725 1.77-10.725h2.227L21.634 41.25h-2.605s-2.162-10.369-2.178-10.552h-.034c-.019.211-2.03 10.552-2.03 10.552h-2.645L9.376 28.125h2.269s1.875 10.513 1.884 10.744Z'
          />
        </>
      );
    case '.jpg':
    case '.jpeg':
    case '.png':
      return (
        <>
          <path
            stroke='#A6CCC3'
            fill='none'
            strokeWidth={2}
            d='M34.41 32.037 31.836 35.7l-4.362-5.855a1.5 1.5 0 0 0-2.406 0l-6.781 9.11c-.714.955-.012 2.294 1.201 2.294h21.024c1.194 0 1.9-1.302 1.227-2.262l-4.875-6.95a1.5 1.5 0 0 0-2.456 0h.002Z'
          />
          <path stroke='#FF9810' strokeWidth={2} d='M38.25 24.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z' fill='none' />
          <rect
            width={46}
            height={46}
            x={7}
            y={7}
            stroke={borderColor}
            strokeWidth={2}
            opacity={0.67}
            rx={4}
            fill='none'
          />
        </>
      );
    case '.avif':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path
            fill={borderColor}
            d='M18.738 38h-1.977l3.012-8.727h2.378L25.16 38h-1.977l-2.186-6.733h-.069L18.738 38Zm-.124-3.43h4.67v1.44h-4.67v-1.44ZM26.697 29.273l2.11 6.63h.08l2.114-6.63h2.046L30.038 38H27.66l-3.012-8.727h2.05ZM35.942 29.273V38h-1.845v-8.727h1.845ZM37.46 38v-8.727h5.779v1.52h-3.933v2.08h3.55v1.522h-3.55V38H37.46Z'
          />
        </>
      );

    case '.mp4':
      return (
        <>
          <rect
            width={46}
            height={46}
            x={7}
            y={7}
            stroke={borderColor}
            strokeWidth={2}
            opacity={0.67}
            rx={4}
            fill='none'
          />
          <path
            fill='#BC1948'
            d='M41.737 30a1.105 1.105 0 0 1-.576.936l-19.2 10.896a1.15 1.15 0 0 1-.623.168 1.2 1.2 0 0 1-.576-.144 1.08 1.08 0 0 1-.624-.936V30h21.6Z'
          />
          <path
            fill='#E8467C'
            d='M41.737 30a1.107 1.107 0 0 0-.576-.937l-19.2-10.91a1.249 1.249 0 0 0-1.2 0 1.081 1.081 0 0 0-.623.938V30h21.6Z'
          />
        </>
      );
    case '.pptx':
      return (
        <>
          <path
            fill={fillColor}
            d='M17.813 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H17.812a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path
            fill='#ED6C47'
            d='M39.375 33.75 37.5 31.875h-3.75l-1.875 1.875v5.574c1.708 2.295 4.42 3.801 7.5 3.801a9.375 9.375 0 0 0 9.375-9.375h-9.375Z'
          />
          <path fill='#FF8F6B' d='M31.875 28.176v5.574h7.5v-9.375c-3.08 0-5.792 1.506-7.5 3.8Z' />
          <path fill='#FFC7B5' d='M41.25 22.5a9.375 9.375 0 0 1 9.375 9.375H41.25V22.5Z' />
          <path
            fill='#C43E1C'
            d='M6.563 46.875h20.625A2.813 2.813 0 0 0 30 44.062V23.439a2.813 2.813 0 0 0-2.813-2.813H6.563a2.812 2.812 0 0 0-2.812 2.813v20.625a2.813 2.813 0 0 0 2.813 2.812Z'
          />
          <path
            fill={fillColor}
            fillRule='evenodd'
            d='M21.824 27.487c-.92-.799-2.24-1.2-3.966-1.2h-5.141V41.25h2.212l.01-5.28h2.75c1.1 0 2.059-.22 2.895-.642.837-.42 1.49-.999 1.943-1.758.453-.758.671-1.632.671-2.607 0-1.517-.46-2.675-1.374-3.476Zm-3.867 6.263H14.93v-5.625h3.117c1.854 0 2.881 1.237 2.881 2.885 0 .85-.343 1.635-.826 2.078-.484.44-1.2.662-2.144.662Z'
            clipRule='evenodd'
          />
        </>
      );
    case '.psd':
      return (
        <>
          <path
            fill={fillColor}
            d='M17.813 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H17.812a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#clip0_29594_140428)'>
            <path
              fill='#001E36'
              d='M8.523 21.203h16.954a4.645 4.645 0 0 1 4.648 4.649v16.296a4.645 4.645 0 0 1-4.648 4.649H8.523a4.645 4.645 0 0 1-4.648-4.649V25.852a4.645 4.645 0 0 1 4.648-4.649Z'
            />
            <path
              fill='#31A8FF'
              d='M9.781 39.152V27.897c0-.077.033-.12.11-.12.186 0 .36 0 .612-.011.263-.011.536-.011.831-.022.296-.011.613-.011.952-.022.339-.011.667-.011.995-.011.897 0 1.64.11 2.253.339.547.186 1.05.492 1.466.897.35.35.623.776.798 1.247.165.46.252.93.252 1.422 0 .94-.219 1.717-.656 2.33a3.747 3.747 0 0 1-1.761 1.334c-.744.273-1.564.372-2.461.372-.263 0-.438 0-.547-.011-.11-.011-.262-.011-.47-.011v3.51a.136.136 0 0 1-.12.154H9.911c-.087 0-.13-.044-.13-.142Zm2.385-9.265v3.675c.153.011.295.022.426.022h.58c.426 0 .853-.065 1.258-.197a1.88 1.88 0 0 0 .897-.58c.23-.273.339-.645.339-1.126a1.8 1.8 0 0 0-.252-.973 1.586 1.586 0 0 0-.766-.624 3.209 3.209 0 0 0-1.29-.218c-.285 0-.536 0-.744.01-.219-.01-.372 0-.448.011ZM24.875 32.896a3.872 3.872 0 0 0-1.05-.372 5.765 5.765 0 0 0-1.225-.142 2.203 2.203 0 0 0-.656.076.562.562 0 0 0-.34.219.58.58 0 0 0-.087.295c0 .099.044.197.11.285.098.12.23.218.371.295.252.131.514.252.777.36.59.198 1.16.471 1.684.8.361.229.657.535.864.907.175.35.263.733.252 1.127a2.545 2.545 0 0 1-.427 1.454 2.74 2.74 0 0 1-1.225.974c-.536.23-1.192.35-1.98.35a7.53 7.53 0 0 1-1.487-.142 4.41 4.41 0 0 1-1.116-.35c-.076-.044-.13-.12-.12-.208V36.92c0-.033.011-.077.044-.099.033-.022.066-.01.098.011.427.252.875.427 1.357.536.415.11.853.164 1.29.164.416 0 .711-.055.908-.153a.508.508 0 0 0 .295-.46c0-.152-.087-.295-.262-.437-.175-.142-.536-.306-1.072-.514a6.686 6.686 0 0 1-1.553-.787 2.833 2.833 0 0 1-.831-.93 2.348 2.348 0 0 1-.252-1.116c0-.47.131-.918.372-1.323a2.696 2.696 0 0 1 1.148-1.006c.514-.263 1.16-.383 1.936-.383.449 0 .908.033 1.357.098.328.044.645.132.94.252.044.01.088.054.11.098a.546.546 0 0 1 .021.131v1.783a.135.135 0 0 1-.054.11c-.099.022-.153.022-.197 0Z'
            />
          </g>
          <defs>
            <clipPath id='clip0_29594_140428'>
              <path fill={fillColor} d='M3.875 21.203h26.25v25.594H3.875z' />
            </clipPath>
          </defs>
        </>
      );
    case '.sketch':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='#FDB300' d='m23.8 25.248 6.2-.655 6.2.655 4.8 6.444L30 44.5l-11-12.81 4.8-6.443Z' />
          <path fill='#EA6C00' d='M23.456 31.691 30 44.501 19 31.69h4.456ZM36.544 31.691 30 44.501l11-12.81h-4.456Z' />
          <path fill='#FDAD00' d='M23.456 31.691h13.089L30 44.501l-6.544-12.81Z' />
          <path fill='#FDD231' d='m30 24.593-6.2.655-.344 6.444 6.544-7.1ZM30 24.593l6.2.655.344 6.444-6.544-7.1Z' />
          <path fill='#FDAD00' d='m41 31.692-4.8-6.444.344 6.444H41ZM19 31.692l4.8-6.444-.345 6.444H19Z' />
          <path fill='#FEEEB7' d='m30 24.593-6.544 7.099h13.089L30 24.592Z' />
        </>
      );
    case '.html':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill={borderColor} d='M43.5 48h-27a1.5 1.5 0 0 1 0-3h27a1.5 1.5 0 0 1 0 3Z' opacity={0.67} />
          <path
            fill='#69AFE5'
            d='M39.158 38.33a1.5 1.5 0 1 0 2.684 1.341l-2.684-1.341ZM43.5 33l1.342.671a1.5 1.5 0 0 0 0-1.341L43.5 33Zm-1.658-6.67a1.5 1.5 0 1 0-2.684 1.341l2.684-1.341Zm-21 1.341a1.5 1.5 0 1 0-2.684-1.341l2.684 1.341Zm-4.342 5.33-1.342-.671a1.5 1.5 0 0 0 0 1.341l1.342-.67Zm1.658 6.67a1.5 1.5 0 1 0 2.684-1.341l-2.684 1.341Zm23.684 0 3-6-2.684-1.341-3 6 2.684 1.341Zm3-7.341-3-6-2.684 1.341 3 6 2.684-1.341Zm-26.684-6-3 6 2.684 1.341 3-6-2.684-1.341Zm-3 7.341 3 6 2.684-1.341-3-6-2.684 1.341Z'
          />
          <path fill='#000' d='m33 24-6 18 6-18Z' />
          <path stroke='#69AFE5' strokeLinecap='round' strokeWidth={3} d='m33 24-6 18' />
        </>
      );
    case '.zip':
      return (
        <>
          <path
            fill='#FFB900'
            d='m30 15-4.242-4.242A6 6 0 0 0 21.516 9H6a3 3 0 0 0-3 3v36a3 3 0 0 0 3 3h48a3 3 0 0 0 3-3V18a3 3 0 0 0-3-3H30Z'
          />
          <path
            fill='#FFD75E'
            d='m30 15-4.242 4.242A6 6 0 0 1 21.516 21H3v27a3 3 0 0 0 3 3h48a3 3 0 0 0 3-3V18a3 3 0 0 0-3-3H30Z'
          />
          <path
            fill='url(#a)'
            d='m30 15-4.242 4.242A6 6 0 0 1 21.516 21H3v27a3 3 0 0 0 3 3h48a3 3 0 0 0 3-3V18a3 3 0 0 0-3-3H30Z'
          />
          <path
            fill='#E67628'
            d='M6 49.5c-1.119 0-2.13-.427-2.919-1.102A2.964 2.964 0 0 0 6 51h48c1.515 0 2.715-1.14 2.92-2.6a4.455 4.455 0 0 1-2.92 1.1H6Z'
          />
          <path
            fill={fillColor}
            d='M26.508 20.742 32.25 15H30l-4.242 4.242A6 6 0 0 1 21.516 21H3v1.5h19.266a6 6 0 0 0 4.242-1.758Z'
            opacity={0.4}
          />
          <path
            fill='#BF5712'
            fillRule='evenodd'
            d='M6.75 30h19.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V39h3v-6H6v-2.25a.75.75 0 0 1 .75-.75ZM18 39h6v-6h-6v6Zm14.25 0h-1.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75Zm4.5 0h1.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75Zm7.5 0h-1.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75Zm4.5 0h1.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75Zm7.5 0h-1.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75ZM3 39h2.25a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75H3v6Z'
            clipRule='evenodd'
          />
          <defs>
            <linearGradient id='a' x1={3} x2={3} y1={15} y2={51} gradientUnits='userSpaceOnUse'>
              <stop stopColor={fillColor} stopOpacity={0.01} />
              <stop offset={0.999} stopColor='#FFD75E' stopOpacity={0.3} />
            </linearGradient>
          </defs>
        </>
      );
    case '.mp3':
      return (
        <>
          <rect
            width={46}
            height={46}
            x={7}
            y={7}
            stroke={borderColor}
            strokeWidth={2}
            opacity={0.67}
            rx={4}
            fill='none'
          />
          <path
            stroke='#69AFE5'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={3.2}
            d='M21.95 41.25a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM37.95 38.05a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z'
            clipRule='evenodd'
            fill='none'
          />
          <path
            fill='#69AFE5'
            d='M41.15 18.85h1.6a1.6 1.6 0 0 0-1.914-1.569l.314 1.569Zm-16 3.2-.314-1.569a1.6 1.6 0 0 0-1.286 1.569h1.6Zm17.6 12.8v-16h-3.2v16h3.2Zm-1.914-17.569-16 3.2.628 3.138 16-3.2-.628-3.138ZM23.55 22.05v16h3.2v-16h-3.2Zm17.286.031-16 3.2.628 3.138 16-3.2-.628-3.138Z'
          />
        </>
      );
    case '.ai':
      return (
        <>
          <path
            fill={fillColor}
            d='M17.813 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H17.812a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#clip0_29594_140493)'>
            <g clipPath='url(#clip1_29594_140493)'>
              <path
                fill='#300'
                d='M8.523 21.203h16.954a4.645 4.645 0 0 1 4.648 4.649v16.296a4.645 4.645 0 0 1-4.648 4.649H8.523a4.645 4.645 0 0 1-4.648-4.649V25.852a4.645 4.645 0 0 1 4.648-4.649Z'
              />
              <path
                fill='#FF9A00'
                d='M16.563 36.516h-4.069l-.831 2.57a.192.192 0 0 1-.208.153H9.4c-.12 0-.153-.065-.12-.197L12.8 28.903c.033-.11.066-.23.11-.36.044-.23.066-.47.066-.712-.012-.054.032-.109.087-.12h2.833c.087 0 .131.033.142.088l3.992 11.265c.033.12 0 .175-.11.175h-2.285c-.077.011-.153-.043-.175-.12l-.897-2.603Zm-3.434-2.22h2.778a15.46 15.46 0 0 0-.252-.788 33.282 33.282 0 0 1-.295-.94c-.11-.34-.208-.668-.317-1.007-.11-.339-.208-.656-.296-.973-.087-.307-.164-.59-.24-.853h-.022c-.099.47-.219.94-.372 1.41-.164.526-.328 1.072-.503 1.62a21.49 21.49 0 0 1-.481 1.53Zm9.34-4.67c-.36.01-.71-.132-.973-.384a1.421 1.421 0 0 1-.372-1.006c-.011-.372.131-.722.394-.973a1.4 1.4 0 0 1 .973-.383c.427 0 .755.131.995.383.241.262.372.612.361.973.011.372-.12.733-.383 1.006a1.286 1.286 0 0 1-.995.383Zm-1.225 9.493v-8.422c0-.11.044-.153.142-.153h2.166c.099 0 .142.055.142.153v8.422c0 .12-.043.175-.142.175h-2.144c-.11 0-.164-.066-.164-.175Z'
              />
            </g>
          </g>
          <defs>
            <clipPath id='clip0_29594_140493'>
              <path fill={fillColor} d='M3.875 21.203h26.25v25.594H3.875z' />
            </clipPath>
            <clipPath id='clip1_29594_140493'>
              <path fill={fillColor} d='M3.875 21.203h26.25v25.594H3.875z' />
            </clipPath>
          </defs>
        </>
      );
    case '.xd':
      return (
        <>
          <path
            fill={fillColor}
            d='M17.813 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H17.812a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <g clipPath='url(#a)'>
            <path
              fill='#470137'
              d='M8.523 21.203h16.954a4.645 4.645 0 0 1 4.648 4.649v16.296a4.645 4.645 0 0 1-4.648 4.649H8.523a4.645 4.645 0 0 1-4.648-4.649V25.852a4.645 4.645 0 0 1 4.648-4.649Z'
            />
            <path
              fill='#FF61F6'
              d='m17.678 27.93-3.28 5.414 3.5 5.742c.021.044.032.087.021.131-.01.044-.055.011-.12.022h-2.505c-.175 0-.295-.01-.372-.12-.23-.46-.47-.908-.7-1.367a44.27 44.27 0 0 0-.743-1.379c-.263-.47-.525-.94-.788-1.421h-.022c-.23.47-.481.94-.733 1.41-.251.47-.503.941-.743 1.4-.252.46-.504.93-.755 1.379-.044.109-.131.12-.252.12H7.78c-.044 0-.076.022-.076-.033a.152.152 0 0 1 .021-.12l3.402-5.578-3.314-5.611c-.033-.044-.044-.088-.022-.11.022-.032.066-.043.11-.043h2.482c.055 0 .11.01.153.022a.31.31 0 0 1 .11.098c.207.47.448.94.7 1.41.262.471.514.93.787 1.39.263.46.503.919.733 1.389h.022c.23-.481.47-.952.71-1.41.241-.46.493-.92.745-1.38.251-.458.492-.929.732-1.377.011-.044.033-.088.066-.11a.209.209 0 0 1 .142-.021h2.308a.1.1 0 0 1 .12.076c.011.011-.01.055-.032.077ZM22.732 39.469a5.438 5.438 0 0 1-2.351-.492 3.813 3.813 0 0 1-1.652-1.488c-.405-.667-.602-1.498-.602-2.493a4.492 4.492 0 0 1 .602-2.308 4.543 4.543 0 0 1 1.739-1.696c.766-.426 1.684-.634 2.767-.634.055 0 .131 0 .23.01.098.012.208.012.339.023v-3.456c0-.077.033-.12.11-.12h2.22c.054-.012.098.032.109.076V37.325c0 .197.01.416.022.656.022.23.033.449.044.635 0 .076-.033.142-.11.175-.569.24-1.17.415-1.783.525a9.651 9.651 0 0 1-1.684.153Zm1.072-2.188V32.47c-.098-.022-.197-.044-.295-.055-.12-.01-.241-.022-.361-.022-.427 0-.854.088-1.236.285-.372.186-.69.46-.93.81-.24.35-.36.82-.36 1.388-.012.383.054.766.185 1.127.11.295.274.557.492.776.208.197.46.35.744.438.295.098.602.142.908.142.164 0 .317-.011.46-.022a.958.958 0 0 0 .393-.055Z'
            />
          </g>
          <defs>
            <clipPath id='a'>
              <path fill={fillColor} d='M3.875 21.203h26.25v25.594H3.875z' />
            </clipPath>
          </defs>
        </>
      );
    case '.xlsx':
    case '.xls':
      return (
        <>
          <path
            fill={fillColor}
            d='M17.813 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H17.812a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M53.05 15 45 6.95v7.112a.94.94 0 0 0 .938.938h7.111Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M55.8 14.726 45.649 4.573a2.832 2.832 0 0 0-1.988-.823H18.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM45.375 6.951 53.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM18.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H18.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
          <path fill='#134A2C' d='M46.875 43.125h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path fill='#185C37' d='M37.5 43.125h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path fill='#21A366' d='M46.875 35.625h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path fill='#107C41' d='M37.5 35.625h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path fill='#33C481' d='M46.875 28.125h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path fill='#21A366' d='M37.5 28.125h-3.75a1.875 1.875 0 1 1 0-3.75h3.75a1.875 1.875 0 1 1 0 3.75Z' />
          <path
            fill='#107C41'
            d='M6.563 46.875h20.625A2.813 2.813 0 0 0 30 44.062V23.439a2.813 2.813 0 0 0-2.813-2.813H6.563a2.812 2.812 0 0 0-2.812 2.813v20.625a2.813 2.813 0 0 0 2.813 2.812Z'
          />
          <path
            fill='#F9F7F7'
            d='m11.25 41.25 4.076-7.519-3.735-7.481h3.004l2.038 4.78c.188.453.317.793.386 1.016h.029c.133-.364.273-.717.42-1.058l2.178-4.738h2.756l-3.828 7.438L22.5 41.25h-2.934L17.212 36a4.825 4.825 0 0 1-.28-.703h-.034a3.617 3.617 0 0 1-.272.68L14.2 41.25H11.25Z'
          />
        </>
      );

    case 'blank':
      return (
        <>
          <path
            fill={fillColor}
            d='M12.188 54.375h35.624a.94.94 0 0 0 .938-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874a.94.94 0 0 0 .938.938Z'
          />
          <path fill={fillColor} d='M48 18v-.879l-9-9v8.38c0 .824.675 1.5 1.5 1.5H48Z' />
          <path
            fill={borderColor}
            fillRule='evenodd'
            d='M49.8 14.726 39.649 4.573a2.832 2.832 0 0 0-1.988-.823H12.187a2.816 2.816 0 0 0-2.812 2.813v46.874a2.816 2.816 0 0 0 2.813 2.813h35.624a2.816 2.816 0 0 0 2.813-2.813V16.715c0-.75-.292-1.457-.825-1.988ZM39.375 6.951 47.425 15h-7.112a.94.94 0 0 1-.938-.938V6.952ZM12.187 54.375h35.626a.94.94 0 0 0 .937-.938V16.876h-8.438a2.816 2.816 0 0 1-2.812-2.813V5.626H12.187a.94.94 0 0 0-.937.938v46.874c0 .518.42.938.938.938Z'
            clipRule='evenodd'
            opacity={0.67}
          />
        </>
      );
    default:
      return (
        <>
          <path
            fill='#E5E5E5'
            d='M48.21 18.691v33.086A3.226 3.226 0 0 1 44.989 55H15.223A3.226 3.226 0 0 1 12 51.777V8.223A3.226 3.226 0 0 1 15.223 5H34.52l13.69 13.691Z'
          />
          <path
            fill='#BABABA'
            d='M19 26.663a.88.88 0 0 1 .88-.88h20.24a.88.88 0 0 1 .88.88v.933H19.88a.88.88 0 0 1-.88-.88v-.053Zm0 4.038a.88.88 0 0 1 .88-.88h20.24a.88.88 0 0 1 .88.88v.054a.88.88 0 0 1-.88.88H19.88a.88.88 0 0 1-.88-.88v-.053Zm0 4.048a.88.88 0 0 1 .88-.88h13.893a.88.88 0 0 1 .88.88v.053a.88.88 0 0 1-.88.88H19.88a.88.88 0 0 1-.88-.88v-.053Z'
          />
          <path fill='#CCC' d='m36.385 18.223 11.826 9.58v-8.994l-6.709-3.897-5.117 3.31Z' opacity={0.6} />
          <path fill='#BABABA' d='M48.21 18.691H37.743a3.226 3.226 0 0 1-3.222-3.222V5l13.69 13.691Z' />;
        </>
      );
  }
};

const FileSVGIcon = ({
  name = '',
  style = {},
  fill = '',
  viewBox = '',
  height = '24',
  width = '24',
  className = '',
  strokeWidth = 1.5,
  bgfill = 'none',
  stroke = '',
  stopColor = ''
}) => {
  return (
    <svg
      stroke={stroke}
      width={width}
      height={height}
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox={viewBox || '0 0 24 24'}
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      {getPath(name, { fill, strokeWidth, bgfill, stroke, stopColor })}
    </svg>
  );
};

export default FileSVGIcon;
